module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av598-d06bb014a72988fddd91a195d0d788e8.jpg";